export default "__VITE_ASSET__D6Hx$pJd__"